import { useLayoutEffect, useState } from 'react';
import useMeasure from 'react-use-measure';
import ResizeObserver from 'resize-observer-polyfill';

const useHideChips = ({ chipsArray = [], chipRefs }) => {
  const passedChipRefs = { ...chipRefs };
  const [moreButtonChips, setMoreButtonChips] = useState([]);
  const [chipsContainerRef, { width: chipsContainerWidth }] = useMeasure({ polyfill: ResizeObserver });
  // if the last chip overflow the container, hide it.
  const setChipsOpacity = () => {
    let lastFullChipIndex = -1;
    let chipsLengthSum = 0;
    passedChipRefs.current.forEach((chipRef, index) => {
      if (chipRef) {
        if (chipRef.clientWidth + chipsLengthSum <= chipsContainerWidth) {
          lastFullChipIndex = index;
        }
        chipsLengthSum += chipRef.clientWidth;
      }
    });
    setMoreButtonChips(chipsArray.slice(lastFullChipIndex + 1));
  };

  const mQuery = () => {
    // if the container was too short to contain one chip last time,
    // show the first chip when the chip container is wider than 1 and half chip.
    if (moreButtonChips.length === chipsArray.length && passedChipRefs.current.length > 0) {
      const firstChipLength = passedChipRefs.current[0].clientWidth;
      const halfSecondChipLength = passedChipRefs.current[1].clientWidth / 2;
      if (chipsContainerWidth >= firstChipLength + halfSecondChipLength) {
        setChipsOpacity();
      }
    } else {
      setChipsOpacity();
    }
  };

  // watching on the width of chips container
  useLayoutEffect(() => {
    mQuery();
  }, [chipsContainerWidth]);

  return [chipsContainerRef, moreButtonChips];
};

export default useHideChips;
